import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import BrandMark from "./BrandMark";

export default function Footer() {
  const { t } = useI18n();

  return (
    <footer className="minimal-footer">
      <div className="container minimal-footer-inner">
        <BrandMark compact />
        <nav>
          <Link to="/gallery">{t.nav.shopAll}</Link>
          <Link to="/gallery/print">{t.nav.print}</Link>
          <Link to="/gallery/original">{t.nav.original}</Link>
          <Link to="/contact">{t.nav.contact}</Link>
        </nav>
      </div>
      <div className="container minimal-footer-legal">
        <span>© {new Date().getFullYear()} Dalila Di Maria</span>
        <span>{t.footer.rights}</span>
      </div>
    </footer>
  );
}
